import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../../redux/actions/loadingActions";
import { getUserRole } from "../../utils/getUserRole";
import { setUserRole } from "../../../redux/actions/authActions";
import { mostrarError, mostrarInfo } from "../../utils/Alertas";
import TextField from "@mui/material/TextField";

interface Props {
	onSuccess: () => void;
}

const LoginForm: React.FC<Props> = ({ onSuccess }) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const dispatch = useDispatch();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            if (!email && !password) {
                mostrarInfo("Por favor, ingresa tu correo y tu contraseña.");
            } else if (!email) {
                mostrarInfo("Por favor, ingresa tu correo electrónico.");
            } else {
                mostrarInfo("Por favor, ingresa tu contraseña.");
            }
            return;
        }

        dispatch(showLoading());        
        try {
            await signInWithEmailAndPassword(auth, email, password);
            const rol = await getUserRole();
            if (rol) {
                dispatch(setUserRole(rol));
            }
            onSuccess();
        } catch (err) {
            console.error(err);
            mostrarError("Correo o contraseña incorrectos");
        } finally {
            dispatch(hideLoading());
        }
    };

	return (
        
		<form onSubmit={handleLogin} className="auth-form">
			<h2>Iniciar sesión</h2>

			<TextField
                type="email"
                label="Correo electrónico"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                margin="normal"
            />

            <TextField
                type="password"
                label="Contraseña"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                margin="normal"
                style={{ marginTop: "10px" }}
            />
			<button type="submit">Entrar</button>
		</form>
	);
};

export default LoginForm;
